import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { BiWorld } from "react-icons/bi";
import { BodyText } from "../../components/BodyText/BodyText";
import { Button } from "../../components/Button/Button";
import * as S from "./Services.styles";

export const Services = () => {
  return (
    <S.ServicesWrapper id="services">
      <S.ServiceTitle>Serviços</S.ServiceTitle>
      <S.CardsWrapper>
        <S.Card>
          <S.CardHeader>
            <h4>Terapia Individual</h4>
            <IoChatbubbleEllipsesOutline size={28} color="white" />
          </S.CardHeader>
          <BodyText>
            <p>
              A terapia individual é um espaço seguro e acolhedor para você se
              conhecer melhor, superar desafios emocionais e desenvolver uma
              vida mais equilibrada.
            </p>
          </BodyText>
          <Button color="var(--primary)" text="Consulte valores" />
        </S.Card>
        <S.Card>
          <S.CardHeader2>
            <h4>Terapia para brasileiros no exterior</h4>
            <BiWorld size={32} color="white" />
          </S.CardHeader2>
          <BodyText>
            <p>
              Com o auxílio da Psicologia Intercultural a terapia oferece aos
              brasileiros imigrantes e expatriados um espaço seguro para lidar
              com os desafios emocionais da imigração, promovendo adaptação,
              fortalecimento da identidade e bem-estar emocional.
            </p>
          </BodyText>
          <Button color="var(--primary)" text="Consulte valores" />
        </S.Card>
      </S.CardsWrapper>
    </S.ServicesWrapper>
  );
};
